import { render, staticRenderFns } from "./SSRTable.vue?vue&type=template&id=117a5858&scoped=true&"
import script from "./SSRTable.vue?vue&type=script&lang=js&"
export * from "./SSRTable.vue?vue&type=script&lang=js&"
import style0 from "./SSRTable.vue?vue&type=style&index=0&id=117a5858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117a5858",
  null
  
)

export default component.exports